import React from 'react';

const About: React.FC = () => {
  return (
    <section id="about" className="py-20 bg-gradient-to-b from-black to-gray-900 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-16">
          <h2 className="text-4xl font-bold mb-4">Meet the Band</h2>
          <div className="h-1 w-20 bg-blue-500 mx-auto"></div>
        </div>
        
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12">
          {/* Shourya */}
          <div className="bg-gray-800 rounded-lg overflow-hidden shadow-xl transform transition-all hover:scale-105">
            <div className="relative h-80 overflow-hidden">
              <img 
                src="/images/shourya.jpg" 
                alt="Shourya - Piano Prodigy" 
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://via.placeholder.com/400x300?text=Shourya';
                }}
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-blue-300">Shourya</h3>
              <p className="text-gray-300 text-lg mb-4">Piano Prodigy</p>
              <p className="text-gray-400 mb-6">
                At just 9 years old, Shourya has already mastered the piano with his incredible talent and dedication. 
                His tiny fingers dance across the keys, creating melodies that captivate audiences of all ages.
              </p>
              <div className="flex items-center text-sm text-gray-400">
                <span className="mr-2">Favorite artists:</span>
                <span className="text-blue-300">A.R. Rahman</span>
              </div>
            </div>
          </div>
          
          {/* Krishna */}
          <div className="bg-gray-800 rounded-lg overflow-hidden shadow-xl transform transition-all hover:scale-105">
            <div className="relative h-80 overflow-hidden">
              <img 
                src="/images/krishna.jpg" 
                alt="Krishna - Vocal & Guitar Sensation" 
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  target.src = 'https://via.placeholder.com/400x300?text=Krishna';
                }}
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-blue-300">Krishna</h3>
              <p className="text-gray-300 text-lg mb-4">Vocal & Guitar Sensation</p>
              <p className="text-gray-400 mb-6">
                Krishna, also 9, is a natural-born performer with an incredible voice and guitar skills beyond his years. 
                His passion for music shines through in every note he plays and sings.
              </p>
              <div className="flex items-center text-sm text-gray-400">
                <span className="mr-2">Favorite artists:</span>
                <span className="text-blue-300">Diljit Dosanjh, Karan Aujla, Jaani</span>
              </div>
            </div>
          </div>

          {/* Shivansh */}
          <div className="bg-gray-800 rounded-lg overflow-hidden shadow-xl transform transition-all hover:scale-105">
            <div className="relative h-80 overflow-hidden">
              <img 
                src="/images/shivansh.jpg" 
                alt="Shivansh - Drumming Virtuoso" 
                className="w-full h-full object-cover"
                loading="lazy"
                onError={(e) => {
                  const target = e.target as HTMLImageElement;
                  // Use a drum-themed placeholder if the image fails to load
                  target.src = 'https://img.icons8.com/emoji/192/drum-emoji.png';
                }}
              />
            </div>
            <div className="p-6">
              <h3 className="text-2xl font-bold mb-2 text-blue-300">Shivansh</h3>
              <p className="text-gray-300 text-lg mb-4">Drumming Virtuoso</p>
              <p className="text-gray-400 mb-6">
                Shivansh, age 9, is a natural rhythm master with incredible timing and energy behind the drums. 
                His dynamic beats and creative percussion add the perfect foundation to the band's sound.
              </p>
              <div className="flex items-center text-sm text-gray-400">
                <span className="mr-2">Favorite artists:</span>
                <span className="text-blue-300">Shah Rukh Khan, Diljit Dosanjh</span>
              </div>
            </div>
          </div>
        </div>
        
        <div className="mt-16 text-center">
          <p className="text-xl text-gray-300 max-w-3xl mx-auto">
            Together, Shourya, Shivansh, and Krishna form the incredible ShourShivKrish Band, bringing joy and amazement to audiences with their extraordinary musical abilities.
          </p>
        </div>
      </div>
    </section>
  );
};

export default About;
